'use client'

import {SubTitle} from "../atoms/typographies";
import Image from "next/image";
import * as React from "react";
import {PropsWithChildren} from "react";
import styled from "styled-components";

const StyledNoResult = styled.div`
  text-align: center;
  img{
    display: block;
    margin: 10px auto;
  }
`
export const NoResult = ({children}: PropsWithChildren) => {
  return <div className="flex w-full bg-white rounded p-4 my-4 items-center justify-center">
    <div className="flex flex-col items-center">
      <Image src={'/images/no_result.jpg'} alt={"image"} width={200} height={200}/>
      <SubTitle>Aucun résultat</SubTitle>
      <div>{children}</div>
    </div>
  </div>
}

export const ErrorResult = ({code, message}: { code: number, message: string }) => {
  return <StyledNoResult>
    <Image src={'/images/no_result.jpg'} alt={"image"} width={300} height={300}/>
    <SubTitle>Oops une erreur est survenue</SubTitle>
    <div>[{code}] {message}</div>
  </StyledNoResult>
}
